import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Prevent custom element double registration errors
const originalDefine = customElements.define;
customElements.define = function(name: string, constructor: any, options?: any) {
  try {
    if (!customElements.get(name)) {
      originalDefine.call(this, name, constructor, options);
    } else {
      console.warn(`Custom element ${name} already defined, skipping redefinition`);
    }
  } catch (error) {
    console.warn(`Failed to define custom element ${name}:`, error);
  }
};

// Also intercept any global errors from custom elements
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('has already been defined')) {
    event.preventDefault();
    console.warn('Caught and suppressed custom element redefinition error:', event.message);
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // Temporarily disable StrictMode to prevent double rendering issues
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
